import { UserGamificationLevel } from './../../../services/profile/profile.models';
import { ChangeDetectorRef, Component, Inject, NgZone, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { BasePageComponent } from '../../base-page/base-page.component';
import { delay, map, take, takeUntil, tap } from 'rxjs/operators';
import { MinimizeSiteService } from 'src/app/services/utils/hide-footer.service';
import { isPlatformServer } from '@angular/common';
import { Observable, Subject, concat, interval, of } from 'rxjs';
import { GamificationLevelService } from 'src/app/services/profile/gamification-level.service';

@Component({
  selector: 'app-gamification-progress',
  templateUrl: './gamification-progress.component.html',
  styleUrls: ['./gamification-progress.component.scss']
})
export class GamificationProgressComponent extends BasePageComponent {

  isServer: boolean;
  progressPercentage$: Observable<number>;
  source = interval(100);
  playerLoyalityName: string;

  isHidden: boolean = false;
  gamificationIndexSubject = new Subject<number>();
  gamificationIndex$ = this.gamificationIndexSubject.asObservable();
  iconNameIndex: number;
  prevGamification: UserGamificationLevel;
  currentGamification: UserGamificationLevel;

  constructor(
    private cdr: ChangeDetectorRef,
    private router: Router,
    protected translationConfig: TranslationConfig,
    protected minimizeService: MinimizeSiteService,
    private gamificationLevelService: GamificationLevelService,
    @Inject(PLATFORM_ID) private platformId,
    private ngZone: NgZone,
  ) { super() }


  ngOnInit(): void {
    this.isServer = isPlatformServer(this.platformId);

    this.minimizeService.isToolbarNotMinimized().pipe(takeUntil(this.unsubscribe)).subscribe((isNotMinimized) => {
      this.isHidden = !isNotMinimized;
    });

    this.prevGamification = this.gamificationLevelService.getArchivedValue();
    this.currentGamification = this.gamificationLevelService.getCurrentValue();
    this.gamificationIndex$ = of(this.prevGamification?.levelNumber);
    const playerLevelStatus = this.gamificationLevelService.playerLevelStatus(this.prevGamification?.levelNumber);
    this.iconNameIndex = playerLevelStatus.playerLevelIconNameIndex;
    this.playerLoyalityName = playerLevelStatus.playerLoyalityName;
  }

  ngAfterViewInit() {
    if (!this.isServer) {
      let levelDifference = this.currentGamification?.levelNumber - this.prevGamification?.levelNumber;
      let observables = [];

      observables.push(
        this.source.pipe(
          take(1),
          map(value => Math.round(this.prevGamification?.turnover / this.prevGamification?.levelEndsTurnover * 100))
        )
      );

      for (let index = 0; index <= levelDifference; index++) {
        let gamificationIndex = this.prevGamification?.levelNumber + index;
        let percentage = levelDifference > 0 && index < levelDifference ? 100 : Math.round(this.currentGamification?.turnover / this.currentGamification?.levelEndsTurnover * 100);
        let startPosition = index === 0 ? Math.round(this.prevGamification?.turnover / this.prevGamification?.levelEndsTurnover * 100) : 0;

        observables.push(
          this.source.pipe(
            take(percentage - startPosition),
            map(value => startPosition + value + 1),
            delay(300),
            tap(() => {
              const playerLevelStatus = this.gamificationLevelService.playerLevelStatus(gamificationIndex);
              this.iconNameIndex = playerLevelStatus.playerLevelIconNameIndex;
              this.gamificationIndex$ = of(gamificationIndex);
              this.gamificationIndexSubject.next(gamificationIndex);
            })
          )
        );
      }

      observables.push(
        this.source.pipe(
          take(1),
          delay(3000),
          tap(() => {
            this.gamificationLevelService.cleanArchivedValue();
          })
        )
      );

      this.progressPercentage$ = concat(...observables) as Observable<number>;
      this.cdr.detectChanges();
    }
  }

  redirectToProfile(): void {
    this.router.navigate(['', 'client-area', 'main']);
  }
}
